import * as moment from "moment";
import { WebPortalClient } from "webportalclient";
import { DeviceNotification } from "../misc/api/DeviceLinkApi/Models/DeviceNotification";

const mapToAlertTemplateId = (deviceId: number): string => {
    switch (deviceId) {
        case 1:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK1.CFCardError";
        case 2:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK1.RecordingNotStarted";
        case 3:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK1.RecordingStoppedEarly";
        case 4:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK1.ShortRecording";
        case 5:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK1.RecordingStoppedEarly";
        case 6:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK1.UnconfiguredCard";
        case 8:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK.VitaloJakLogFileCorrupt";
        case 9:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK.VitaloJakUploadFailed";
        case 13:
            return "Vitalograph.WebPortal.Modules.Alerts.VitaloJAK.VitaloJakRecordingStoppedEarly";
        default:
            return "";
        }
}

export const SendAlertToServer = async (client: WebPortalClient, notification: DeviceNotification) => {
    const templateId = mapToAlertTemplateId(notification.id);
    const existingAlert = await client.getAlerts(undefined, `alertTemplateId eq '${templateId}' and originatingIdentifier eq '${notification.originatingIdentifier}'`);

    if (existingAlert['@odata.count'] === 0) {
        await client.postAlert({
            headline: notification.headline,
            content: notification.additionalContent,
            occurred: moment().toISOString(true),
            active: true,
            alertTemplateId: templateId,
            originatingIdentifier: notification.originatingIdentifier
        });
    }
}
